module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "prop-types"
// module id = 2
// module chunks = 0 1